<template>
  <div class="Yesterday">
    <div class="left">
      <!-- 此处支持 reduce increase 两种数据，箭头会切换上下显示 -->
      <div
        class="label"
        :class="{
          increase: pvUp,
          reduce: !pvUp,
          none: publicationStatus && publicationStatus.color === 'offline',
        }"
      >
        昨日浏览
      </div>
      <div class="number">
        {{
          publicationStatus && publicationStatus.color === 'offline' ? '-' : pv
        }}
      </div>
    </div>
    <div class="right">
      <div
        class="label"
        :class="{
          increase: uvUp,
          reduce: !uvUp,
          none: publicationStatus && publicationStatus.color === 'offline',
        }"
      >
        昨日用户
      </div>
      <div class="number">
        {{
          publicationStatus && publicationStatus.color === 'offline' ? '-' : uv
        }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import * as api from 'src/api'
import * as qm from 'src/utils/utils'
/* eslint-enable */
import publicationStatus from 'src/components/publication/publicationStatus.js'

export default {
  mixins: [publicationStatus],
  name: 'Yesterday',
  props: {
    publicationId: {
      type: Number,
      default: () => undefined,
    },
    publicationInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      pv: 0,
      pvUp: true,
      uv: 0,
      uvUp: true,
    }
  },
  computed: {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let start = moment()
        .subtract(2, 'days')
        .format('YYYYMMDD')
      let end = moment()
        .subtract(1, 'days')
        .format('YYYYMMDD')
      let publicationId = this.publicationId || this.$route.params.publicationId
      api
        .Ajax({
          url: '/v1/report.query',
          data: {
            name: 'daily_publication',
            start: start,
            end: end,
            publication: publicationId,
          },
        })
        .then(res => {
          if (res.ok) {
            let beforeYesterday = {}
            let yesterday = {}
            for (let e of res.report.records) {
              let d = String(e.date)
              if (d === end) {
                yesterday = e
              } else if (d === start) {
                beforeYesterday = e
              }
            }
            // yesterday.pv = yesterday.session
            // beforeYesterday.pv = beforeYesterday.session
            this.uv = yesterday.uv || 0
            this.pv = yesterday.pv || 0
            if (this.pv < beforeYesterday.pv) {
              this.pvUp = false
            }
            if (this.uv < beforeYesterday.uv) {
              this.uvUp = false
            }
          }
        })
    },
  },
}
</script>

<style lang="scss">
.Yesterday {
  display: flex;
  padding: 0;
  width: 360px;
  min-height: 80px;

  .left,
  .right {
    height: 96px;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-family: QmNumberFont, RobotoSlab-Regular, serif;
      font-size: 32px;
      line-height: 45px;
      margin-top: 8px;
      color: #333333;
      letter-spacing: 0;
    }
  }

  .right:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 60%;
    width: 1px;
    background-color: #eeeeee;
  }

  .label {
    position: relative;
    font-size: 12px;
    line-height: 14px;
    color: #999999;
    // 三角
    &.reduce:after {
      content: '';
      position: absolute;
      bottom: -14px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid #cccccc;
    }

    &.increase:after {
      content: '';
      position: absolute;
      bottom: -14px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #cccccc;
    }

    &.none:after {
      display: none;
    }
  }
}
</style>
